import styled, { css } from 'styled-components';
import {
  mq,
  backgroundShape,
  getTextType,
  getSpace,
  getColor,
  px2rem
} from '../../../stylesheets/tools';

const StyledCalendarFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: ${px2rem('40px')};
  background-color: #f1f1f1;

  ${mq('m')} {
    // margin: 0 ${px2rem('40px')};
    border-radius: 8px;
  }

  .react-calendar__navigation__arrow {
    svg {
      fill: #000;
    }
  }

  .react-calendar__tile {
    color: ${getColor('black')};
    abbr {
      display: none;
    }
    &.selected {
      ${props =>
        props.theme.siteTheme &&
        css`
          ${backgroundShape(getColor('darkGray'))};
        `};
    }
  }

  .react-calendar__month-view__weekdays__weekday {
    color: ${getColor('black')};
    abbr {
      text-decoration: none;
      text-transform: uppercase;
    }
  }

  .react-calendar {
    flex-grow: 1;
    padding: 40px 20px;

    ${mq('m')} {
      padding: 40px 60px;
    }
  }

  .react-calendar__navigation {
    color: ${getColor('black')};
    justify-content: center;
    padding-bottom: ${px2rem('30px')};
    border-bottom: 1px solid ${getColor('black')};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .react-calendar__navigation__label {
    flex-grow: 0 !important;
    padding: ${getSpace('xxs')} ${getSpace('l')};
    color: ${getColor('black')};
    ${getTextType('tertiary')};
    ${mq('m')} {
      ${getTextType('secondary')};
    }
  }

  .react-calendar__viewContainer {
    padding-top: ${px2rem('20px')};
  }

  .react-calendar__month-view__weekdays__weekday {
    text-align: center;
  }

  .react-calendar__tile {
    position: relative;
    display: flex;
    padding: ${px2rem('10px')} 0;
    width: ${px2rem('30px')};
    height: ${px2rem('30px')};
    justify-content: center;
    margin-top: ${px2rem('10px')};

    &.calendarfilter__nodate {
      .calendarfilter__bg {
        position: absolute;
        width: ${px2rem('30px')};
        height: ${px2rem('30px')};
        top: 10%;
        line-height: ${px2rem('30px')};
        ${mq('m')} {
          top: 10%;
        }

        ${props =>
          props.theme.siteTheme &&
          css`
            ${backgroundShape('transparent')};
          `};

        &.selected {
          ${props =>
            props.theme.siteTheme &&
            css`
              color: ${props.theme.siteTheme.primary};
              ${backgroundShape(getColor('black'))};
            `};
        }
      }
    }

    &.calendarfilter__eventondate {
      .calendarfilter__bg {
        position: absolute;
        width: ${px2rem('30px')};
        height: ${px2rem('30px')};
        top: 10%;
        margin: 0 auto;
        line-height: ${px2rem('30px')};
        ${mq('m')} {
          top: 10%;
        }
        ${props =>
          props.theme.siteTheme &&
          css`
            ${backgroundShape(props.theme.siteTheme.primary)};
          `};
        &.selected {
          ${props =>
            props.theme.siteTheme &&
            css`
              color: ${props.theme.siteTheme.primary};
              ${backgroundShape(getColor('black'))};
            `};
        }
      }
    }
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: #b3b3b3;
  }
`;

export default StyledCalendarFilter;
